import { z } from 'zod';
import { PlaybackType } from '../play';

const ErrorInfo = z.object({
  title: z.string(),
  detail: z.string(),
  code: z.string(),
});

const responseValidator = z.object({
  errors: z.array(ErrorInfo).optional(),
});

type PlaybackProps = {
  playback: PlaybackType;
  jwt?: string;
  subprofileToken?: string;
  position?: number;
};

export const postPlayerEvent = ({
  jwt,
  subprofileToken,
  position,
  playback,
}: PlaybackProps) => {
  // if we don't have a jwt, don't send any requests
  if (!jwt || jwt.length === 0) {
    console.error('No JWT found');
    return Promise.resolve();
  }
  if (!subprofileToken || subprofileToken.length === 0) {
    console.error('No subprofile token found');
    return Promise.resolve();
  }
  if (!playback.playerEventRequest) {
    return Promise.resolve();
  }

  // support live events? Or should we just ignore this since no one resumes live events?
  if (playback.isLive) return Promise.resolve();

  // ignore events that have position less than 10 seconds
  if (!position || position < 10) return Promise.resolve();

  const event = {
    ...playback.playerEventRequest.body,
    timestamp: new Date().toISOString(),
    originator: 'vimond-via-webplay',
    client: {
      // ...playback.playerEventRequest.body.client,
      buildName: 'vimond-via-webplay',
      buildVersion: '1.0.0',
      viewingSession: jwt,
    },
    progress: {
      ...playback.playerEventRequest.body.progress,
      vod: {
        ...playback.playerEventRequest.body.progress.vod,
        position: position.toFixed(2),
      },
    },
  };

  const headers = {
    'content-type': 'application/json',
    accept: 'application/json',
    authorization: `Bearer ${jwt}`,
    'X-Vimond-Subprofile': subprofileToken,
  };

  const requestOptions: RequestInit = {
    method: 'POST',
    headers,
    redirect: 'follow',
    body: JSON.stringify(event),
  };
  return fetch(playback.playerEventRequest.uri, requestOptions)
    .then((res) => {
      if (res.status === 204) return {};
      return res.json();
    })
    .then((json) => {
      const response = responseValidator.parse(json);
      if (response.errors) {
        console.error(response.errors[0]?.detail);
      }
      return;
    });
};
